import axios from 'axios';

import { srUrl } from '../../vars';
import { type DBLogCreate } from '../types/log';

import type { DebugLevel } from '../../_configs/types';

export const createLog = (data: DBLogCreate, debug: DebugLevel) =>
    axios({
        debug,
        idGroup: undefined,
        noLogging: true,
        method: 'put',
        url: `${srUrl}/logs`,
        data,
    });
